<template>
  <!-- space-page begin -->
  <div v-if="page.src === ''" class="w-100 h-100 d-flex flex-column align-items-center justify-content-center">
    <b-spinner variant="secondary" style="width: 3rem; height: 3rem; opacity:.5 ;" label="Spinning" class="mb-5"></b-spinner>
  </div>
  <div v-else class="h-100 mx-auto d-flex align-items-center justify-content-lg-center flex-column" style="max-width:480px;">
    <div class="w-100 p-3 flex-grow-1 flex-lg-grow-0 mb-lg-3 d-flex flex-column justify-content-center align-items-center">
      <div class="p-4 p-lg-5">
        <img :class="page.class" :src="page.src" alt="" class="w-100">
      </div>
      <span class="text-center mb-3"><i18n :path="page.wording" tag="div" class="text-center">
    </i18n></span>
    </div>
    <div class="w-100 p-3 text-center position-sticky" v-if="isRedirectStatus" style="bottom:0;">
      <b-button class="py-3 px-5 font-weight-bold bg-customize border-customize" @click="goTo" block style="background-color:#22BA4F!important;border-color:#22BA4F!important;">{{$t('qrcode.back-to-LINE')}}</b-button>
      <!-- 若按鈕動作非LINE相關，則按鈕移除style樣式 -->
    </div>
  </div>
  <!-- space-page end -->
</template>

<script>
import imgPCmobile from '@/assets/images/illustration/undraw_blank_page.svg';

export default {
  props: {
    // 狀態
    status: String,
    // 導頁 url
    redirectUrl: String,
  },
  data() {
    return {
      // 頁面顯示資料
      page: {
        src: '',
        class: '',
        wording: '',
      },
      timer: 0,
      value: 0,
      max: 160,
    };
  },
  mounted() {
    this.startTimer();
  },
  created() {
    const vm = this;
    // 依照狀態加入頁面顯示資料
    switch (vm.status) {
      case 'redirectOfficalAccount':
        vm.page = {
          src: imgPCmobile,
          class: 'my-3',
          wording: '',
        };
        break;
      case 'blank':
        vm.page = {
          src: '',
          class: 'my-3',
          wording: '',
        };
        break;
      case 'pcCheckFriendFailed':
        vm.page = {
          src: imgPCmobile,
          class: 'my-3',
          wording: 'global.please-use-phone-to-do',
        };
        break;
      default:
        vm.page = {
          src: '',
          class: '',
          wording: '',
        };
        break;
    }
  },
  computed: {
    // 是否為需導頁狀態
    isRedirectStatus() {
      const list = ['redirectOfficalAccount'];
      return list.some((x) => x === this.status);
    },
  },
  methods: {
    startTimer() {
      const vm = this;
      const timer = setInterval(() => {
        vm.value += 1;
        if (vm.value >= 150) clearInterval(timer);
      }, 100);
    },
    goTo() {
      window.location.assign(this.redirectUrl);
    },
  },
};
</script>>
